module.exports = __webpack_public_path__ + "img/_Generic6.586412cb.jpg";